<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group buttonStyle="solid" v-decorator="['isAdd', validatorRules.isAdd]">
              <a-radio-button value="0">➖扣除</a-radio-button>
              <a-radio-button value="1">➕增加</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-if="!quickModal" label="目标" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group buttonStyle="solid" v-model="targetType">
              <a-radio-button value="user"> 用户 </a-radio-button>
              <a-radio-button value="depart"> 班级 </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-col :span="24" v-if="!quickModal && targetType == 'user'">
            <a-form-item label="用户" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userId']" placeholder="请输入用户ID"></a-input>
              <p>或选择用户</p>
              <j-select-user-by-dep v-decorator="['userId', validatorRules.userId]" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="!quickModal && targetType == 'depart'">
            <a-form-item label="班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-select-depart
                v-decorator="['departId', validatorRules.departId]"
                :onlyLeaf="false"
                :rootOpened="true"
                :multi="false"
                :trigger-change="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$store.getters.tenantInfo.coinName" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['integral', validatorRules.integral]"
                :placeholder="'请输入' + $store.getters.tenantInfo.coinName"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['comment']" placeholder="请输入备注"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import JSelectDepart from '@/components/jeecg/JSelectDepart'

export default {
  name: 'SysUserIntegralForm',
  components: {
    JFormContainer,
    JDate,
    JSelectUserByDep,
    JSelectDepart,
  },
  props: {
    userId: {
      type: String,
      default: () => {},
      required: false,
    },
    //流程表单data
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false,
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      targetType: 'user', // user  depart
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        userId: {
          rules: [{ required: true, message: '请选择用户!' }],
        },
        departId: {
          rules: [{ required: true, message: '请选择用户!' }],
        },
        isAdd: {
          rules: [{ required: true, message: '请选择状态!' }],
        },
        integral: {
          rules: [{ required: true, message: '请输入积分!' }],
        },
      },
      url: {
        add: '/system/sysUserIntegral/manualAdd',
        sub: '/system/sysUserIntegral/manualSub',
        departAdd: '/system/sysUserIntegral/manualAddByDepart',
        departSub: '/system/sysUserIntegral/manualSubByDepart',
      },
      quickModal: false
    }
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    },
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData()
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      console.log(record);
      this.quickModal = true
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      if(this.model.userId){
        this.targetType = 'user'
      }else{
        this.targetType = 'depart'
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'userId', 'departId'))
      })
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = 'post'
          let formData = Object.assign(this.model, values)
          if (formData.isAdd == '1') { //加分
            if(formData.unitId){
              formData.ruleCode = 'classroom_perf_add'
              formData.alterId = formData.unitId
            }
            if (that.targetType == 'depart') {
              httpurl += this.url.departAdd
            } else {
              httpurl += this.url.add
            }
          } else { // 减分
            if(formData.unitId){
              formData.ruleCode = 'classroom_perf_sub'
              formData.alterId = formData.unitId
            }
            if (that.targetType == 'depart') {
              httpurl += this.url.departSub
            } else {
              httpurl += this.url.sub
            }
          }
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'userId', 'createTime', 'updateBy', 'updateTime', 'integralType', 'integral'))
    },
  },
}
</script>